import view from './view';
import icon from '@plone/volto/icons/sync.svg';

export default {
  id: 'hp_contact_email',
  title: 'HP Contact Email',
  icon: icon,
  group: 'homepage',
  view: view
};